'use client';

import { type FC, useState } from 'react';
import type { Team } from '@cs-shot/battle-sim';
import { FaShieldAlt, FaStar } from '../icons';
import { bustCache } from './render/battleAssetVersion';

const FALLBACK: Record<Team, typeof FaShieldAlt> = { t: FaStar, ct: FaShieldAlt };

export const SideIcon: FC<{ side: Team; size?: number; className?: string }> = ({ side, size = 30, className }) => {
  const [failed, setFailed] = useState(false);
  if (failed) {
    const Icon = FALLBACK[side];
    return <Icon size={size} className={className} />;
  }
  return (
    <img
      src={bustCache(`/battle/${side}.webp`)}
      alt={side}
      className={className}
      style={{ width: size, height: size, objectFit: 'contain' }}
      onError={() => setFailed(true)}
    />
  );
};
